const DefinedRouteAlias = {
    Rental: {
        label: 'Rental',
        url: '/rental'
    },
    Moorage: {
        label: 'Moorage',
        url: '/moorage'
    },
    AppUser: {
        label: 'App Users',
        url: '#'
    },
    Payments: {
        label: 'Payments',
        url: '#'
    },
    AdminUser: {
        label: 'Admin Users',
        url: '/users'
    }
}

export default DefinedRouteAlias
